import { DomainData } from 'pages/DomainSetup/DomainSetup';
import { IDomain } from '../../types';
import {
  GET_DOMAINS_REQUEST,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAILURE,
  CREATE_DOMAIN_REQUEST,
  CREATE_DOMAIN_SUCCESS,
  CREATE_DOMAIN_FAILURE,
  GET_DOMAIN_REQUEST,
  GET_DOMAIN_SUCCESS,
  GET_DOMAIN_FAILURE,
  VERIFY_DOMAIN_REQUEST,
  VERIFY_DOMAIN_SUCCESS,
  VERIFY_DOMAIN_FAILURE,
  DELETE_DOMAIN_REQUEST,
  DELETE_DOMAIN_SUCCESS,
  DELETE_DOMAIN_FAILURE,
  GetDomainsRequestAction,
  GetDomainsSuccessAction,
  GetDomainsFailureAction,
  CreateDomainRequestAction,
  CreateDomainSuccessAction,
  CreateDomainFailureAction,
  GetDomainRequestAction,
  GetDomainSuccessAction,
  GetDomainFailureAction,
  VerifyDomainRequestAction,
  VerifyDomainSuccessAction,
  VerifyDomainFailureAction,
  DeleteDomainRequestAction,
  DeleteDomainSuccessAction,
  DeleteDomainFailureAction,
  CLEAR_DOMAIN_STATE,
  ClearDomainStateAction,
} from './domain.types';

// Get Domains Actions
export const getDomainsRequest = (): GetDomainsRequestAction => ({
  type: GET_DOMAINS_REQUEST,
});

export const getDomainsSuccess = (
  domains: IDomain[]
): GetDomainsSuccessAction => ({
  type: GET_DOMAINS_SUCCESS,
  payload: domains,
});

export const getDomainsFailure = (error: string): GetDomainsFailureAction => ({
  type: GET_DOMAINS_FAILURE,
  payload: error,
});

// Get Single Domain Actions
export const getDomainRequest = (
  domainName: string
): GetDomainRequestAction => ({
  type: GET_DOMAIN_REQUEST,
  payload: domainName,
});

export const getDomainSuccess = (domain: IDomain): GetDomainSuccessAction => ({
  type: GET_DOMAIN_SUCCESS,
  payload: domain,
});

export const getDomainFailure = (error: string): GetDomainFailureAction => ({
  type: GET_DOMAIN_FAILURE,
  payload: error,
});

// Create Domain Actions
export const createDomainRequest = (
  domainData: Partial<DomainData>,
  provider: 'aws' | 'mailgun'
): CreateDomainRequestAction => ({
  type: CREATE_DOMAIN_REQUEST,
  payload: { domainData, provider },
});

export const createDomainSuccess = (
  domain: IDomain
): CreateDomainSuccessAction => ({
  type: CREATE_DOMAIN_SUCCESS,
  payload: domain,
});

export const createDomainFailure = (
  error: string
): CreateDomainFailureAction => ({
  type: CREATE_DOMAIN_FAILURE,
  payload: error,
});

// Verify Domain Actions
export const verifyDomainRequest = (
  domainId: string,
  source: string,
  provider: 'aws' | 'mailgun'
): VerifyDomainRequestAction => ({
  type: VERIFY_DOMAIN_REQUEST,
  payload: { domain: domainId, source, provider },
});

export const verifyDomainSuccess = (
  domain: IDomain
): VerifyDomainSuccessAction => ({
  type: VERIFY_DOMAIN_SUCCESS,
  payload: domain,
});

export const verifyDomainFailure = (
  error: string
): VerifyDomainFailureAction => ({
  type: VERIFY_DOMAIN_FAILURE,
  payload: error,
});

// Delete Domain Actions
export const deleteDomainRequest = (
  domainName: string,
  provider: 'aws' | 'mailgun'
): DeleteDomainRequestAction => ({
  type: DELETE_DOMAIN_REQUEST,
  payload: { domainName, provider },
});

export const deleteDomainSuccess = (
  domainName: string
): DeleteDomainSuccessAction => ({
  type: DELETE_DOMAIN_SUCCESS,
  payload: domainName,
});

export const deleteDomainFailure = (
  error: string
): DeleteDomainFailureAction => ({
  type: DELETE_DOMAIN_FAILURE,
  payload: error,
});

export const clearDomainState = (): ClearDomainStateAction => ({
  type: CLEAR_DOMAIN_STATE,
});
